import React, { useState } from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../core/common/collapse-header";
const MailBox = () => {
  const [show, setShow] = useState(false);
  const handleShow2 = () => setShow(true);

  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                      Mailbox Reports<span className="count-title">123</span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="card">
                  <div className="card-header">
                   
                    {/* form */}
                    <div className="row align-items-center">
                    <div className="col-md-9">
                                    <div className="form-group">
									    <label className="form-label">Date Range</label>
                                            <div className="input-group datepicker" id="date-range">
                                                <input type="date"  className="form-control col-md-6" id="start_date" name="start_date" style={{width:'50px'}} value="2025-02-18"/>
                                                <span className="input-group-addon bg-primary text-white b-0" style={{ padding: "10px" }}>to</span>
                                                <input type="date" className="form-control col-md-6 datepicker" id="end_date" name="end_date" style={{width:'50px'}} value="2025-03-05"/>
                                            </div>
								    </div>
								</div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-primary"
                        
                      >
                        Search
                      </button>
                    </div>
                    {/* form*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}

        {/* Delete Lead */}
        <div className="modal fade" id="delete_chat" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                    <i className="ti ti-trash-x fs-36 text-danger" />
                  </div>
                  <h4 className="mb-2">Remove cache?</h4>
                  <p className="mb-0">
                    Are you sure you want to remove <br /> lead you selected.
                  </p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete it
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Lead */}
      </>
    </>
  );
};

export default MailBox;